<template>
  <img alt="Vue logo" src="./assets/logo.png">
  <FetchRepo />
</template>

<script>
import FetchRepo from './pages/FetchRepo.vue'

export default {
  name: 'App',
  components: {
    FetchRepo
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  background: whitesmoke;
  min-height: 90vh;
}
</style>
